import { clearGlobalErrors, setGlobalError } from "./validate";

export function initStripeForm(stripe) {
  const forms = document.querySelectorAll("form[data-remote]");
  for (var i = 0; i < forms.length; i++) {
    const form = forms[i];

    form.setAttribute("novalidate", true);

    const getValue = field =>
      document.getElementById(`bank_account_${field}`).value;

    // Setting this in a timeout so we can be sure it is the 2nd item to bind
    setTimeout(
      () =>
        form.addEventListener("ajax:before", async (evt, xhr, settings) => {
          evt.preventDefault();

          if (form.querySelector("p.error")) return;

          const btn = form.querySelector("button");
          btn.disabled = true;

          const result = await stripe.createToken("bank_account", {
            country: "US",
            currency: "usd",
            routing_number: getValue("routing_number"),
            account_number: getValue("account_number"),
            account_holder_name: getValue("account_holder_name"),
            account_holder_type: getValue("account_holder_type")
          });
          btn.disabled = false;

          const { error, token } = result;

          if (token) {
            window.top.postMessage(
              `success,${token.id}`,
              window.PERMITTED_HOST
            );
          } else if (error) {
            clearGlobalErrors();
            setGlobalError(error.message);
          } else {
            clearGlobalErrors();
          }
        }),
      1500
    );
  }
}
